<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Approval Configuration Detail">
		<b-card>
			<b-col cols="12" lg="6">
				{{ modelId }}
				<app-input-combobox-autocomplete :options="approverTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approver Type" id="input-" size="sm" :model.sync="model.approverTypeId"   :selected="model.approverType != null ? model.approverType.name : ''" @input="getApproverTypes"/>
				<app-input-combobox-autocomplete :options="approvalStructures" v-if="model.approverTypeId == 'APPROVAL STRUCTURE'" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Structure" id="input-" size="sm" :model.sync="model.approvalStructureId"   :selected="model.approvalStructure != null ? model.approvalStructure.name : ''" @input="getApprovalStructures" />
				<app-input-textbox id="fieldset-approver-level" v-if="model.approverTypeId == 'SUPERIOR'" label-cols-sm="4" label-cols-lg="3" label="Approver Level" label-for="input-approver-level" size="sm" :model.sync="model.approverLevel" />
				<app-input-combobox-autocomplete :options="userInfos" v-if="model.approverTypeId == 'USER'" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Approver User Name" id="input-" size="sm" :model.sync="model.approverUserNameId"   :selected="model.approverUserName != null ? model.approverUserName.firstName : ''" @input="getUserInfos" />
				<app-input-textbox id="fieldset-stored-procedure-name" v-if="model.approverTypeId == 'STORED PROCEDURE'" label-cols-sm="4" label-cols-lg="3"  label="Stored Procedure Name" label-for="input-stored-procedure-name"  size="sm" :model.sync="model.storedProcedureName"  />
				<!-- <app-input-textbox id="fieldset-approval-type" v-if="model.approverTypeId =='SUPERIOR'" label-cols-sm="4" label-cols-lg="3" label="Approval Type" label-for="input-approval-type" size="sm" :model.sync="model.approvalType"  /> -->
				<!-- <app-input-textbox id="fieldset-approval-type" v-if="model.approverTypeId =='SUPERIOR'" label-cols-sm="4" label-cols-lg="3" label="Approval Type" label-for="input-approval-type" size="sm" :model.sync="model.approvalType"  /> -->
				<!-- <app-input-combobox-autocomplete :options="tipeApproval" v-if="model.approverTypeId =='SUPERIOR'" optionsLabel="text" optionsKey="value" label-cols-sm="4" label-cols-lg="3" label="Approval Type" id="input-" size="sm" :isEditable="true" :model.sync="approvalTypeSelected"/> -->
				<!-- <app-input-combobox-autocomplete :options="tipeApproval" optionsLabel="text" optionsKey="value" label-cols-sm="4" label-cols-lg="3" label="Approval Type" id="input-" size="sm" :isEditable="true" :model.sync="model.ApprovalType" :selected="model.approvalType ? model.approvalType : ''"/> -->
				<app-input-combobox-autocomplete :options="tipeApproval" optionsLabel="text" optionsKey="value" label-cols-sm="4" label-cols-lg="3" label="Approval Type" id="input-" size="sm" :isEditable="true" :model.sync="model.approvalType" :selected="model.approvalType ? model.approvalType : ''"/>
				<app-input-textarea id="fieldset-configuration-content" v-if="model.approvalType == 'APPROVAL INPUT'" label-cols-sm="4" label-cols-lg="3" label="Configuration Content" label-for="input-configuration-content" size="sm" :model.sync="model.configurationContent"  />
				<b-form-group id="fieldset-is-send-notification" label-cols-sm="4" label-cols-lg="3" label="Is Send Notification" label-for="input-is-send-notification">
					<b-form-checkbox id="input-is-send-notification" v-model="model.isSendNotification"></b-form-checkbox>
				</b-form-group>
			</b-col>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-default-white float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-default" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}
</style> 
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ApprovalConfigurationDetail from '@/models/ApprovalConfiguration/ApprovalConfigurationDetail';
import ApprovalConfigurationDetailFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationDetailFilter';

import ApprovalConfiguration from '@/models/ApprovalConfiguration/ApprovalConfiguration';
import ApprovalConfigurationFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {AppInputComboboxAutocomplete,AppInputTextbox,AppInputTextarea,PopupRouterView,},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			approverTypes : [],
			approvalStructures : [],
			userInfos : [],
			isBusy: false,
			tipeApproval: [
				// { text : 'Select All', value : '', selected:true },
				{ text : 'Approval', value : 'APPROVAL'},
				{ text : 'Approval Input', value : 'APPROVAL INPUT' },
			], 
			// approvalTypeSelected : ""
		}
	},
	methods : {
		// updateApproverType(type){
		// 	console.log(type);
		// 	if(type == "STORED PROCEDURE"){
		// 		row.item.approvalStructureId = null;
		// 	}
		// 	if(type == "APPROVAL STRUCTURE"){
		// 		row.item.storedProcedureName = null;
		// 	}			
		// },
		getApprovalConfigurationDetail : async function(id) {
			this.isBusy = true;
			ApprovalConfigurationDetail.getData(this, id).then(result => { this.model = result; this.isBusy = false }).catch(error => { this.isBusy = false; });
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.$emit("addButtonMethod", modalEvent, this.model); 
			}
		},
		resetModal() {
			this.$emit('resetMethod');
		},
	},
	beforeMount() {
		//this.getApproverTypes();
		//this.getApprovalStructures();
		//this.getUserInfos();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getApprovalConfigurationDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getApproverTypes();
				this.getApprovalStructures();
				this.getUserInfos();
			} else {
				this.model = {};
			}
		},
		// 'model.approverTypeId'(newVal){
		// 	console.log(newVal);
		// 	// if(newVal == 'APPROVAL STRUCTURE')
		// 	// {
		// 	// 	this.model.approverUserName = null;
		// 	// 	this.model.storedProcedureName = null;
		// 	// 	this.model.approverLevel = null;
		// 	// }
		// }
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
